import { render, staticRenderFns } from "./DatosFamiliares.vue?vue&type=template&id=7d614a8a&scoped=true&"
import script from "./DatosFamiliares.vue?vue&type=script&lang=js&"
export * from "./DatosFamiliares.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d614a8a",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/forms/DatosFamiliares.vue
// module id = 604
// module chunks = 13